<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="mobile">
          <el-input class="login_ipt" v-model="ruleForm.mobile" placeholder="请输入手机号" @input="setInput()"></el-input>
        </el-form-item>
        <div class="codeText">
          <el-form-item class="login_form_item" prop="code">
            <el-input class="login_ipt codeIpt" v-model="ruleForm.code" placeholder="请输入验证码" @input="setInput()"></el-input>
          </el-form-item>
          <el-button class="login_btn codeBtn" :disabled='isCode' type="primary" @click="getCode('ruleForm')">{{codeText}}</el-button>
        </div>
        <el-form-item class="login_form_item" prop="oldpassword">
          <el-input class="login_ipt" v-model="ruleForm.oldpassword" :type="flagType" maxlength='20' placeholder="请输入密码" @input="setInput('oldpassword')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" maxlength='20' placeholder="请再次确认密码" @input="setInput('password')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <div class="returnLogin">已有账号，返回<span @click="godialog('login','forgot')">登录</span></div>
        <!-- <div class="userText U25">登录或注册即代表同意 <router-link :to="{path:'/'}">用户协议</router-link> 和 <router-link :to="{path:'/'}">隐私政策</router-link>
        </div> -->
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { isEmoji,setInfo } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    var newPassAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('再次确认新密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    return {
      loading:false,
      times: 60,
      flagType: 'password',
      flag: false,
      codeText: '发送验证码',
      isCode: true,
      disabled: true,
      dialogClass: 'user',
      ruleForm: {
        mobile: '',
        password: '',
        code: '',
        oldpassword: ''
      },
      rules: {
        oldpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: '请输入6到20位字符且包含大小写字母及数字',trigger: 'blur'},
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入手机号',trigger: 'change'},
        ],
        password: [
          { validator: newPassAgain, trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: '' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (!that.disabled) {
        if (e.keyCode === 13) {
          that.submitForm('ruleForm')
        }
      }
    })
    //console.log(this.$interface.SignIn)
  },
  methods: {
    
    // 点击快捷跳转 忘记密码 和 注册
    godialog(toval,val){
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    // 获取验证码
    getCode(formName) {
      let that = this;
      that.isCode = true;
      this.$refs[formName].validateField('mobile', (val) => {
        if (val == "") {
          that.isCode = true;
          if (that.times == 60) {
            that.codeText = that.times+'s';
          }
          that.timer = setInterval(() => {
            that.times--;
            that.codeText = that.times+'s';
            if (that.times === 0) {
              that.times = 60;
              that.codeText = '发送验证码';
              that.isCode = false;
              clearInterval(that.timer);
            }
          }, 1000);
          let data = {
            NationCode:'86',
            mobile: that.ruleForm.mobile,
            type: 2
          }
          this.$post(this.$interface.SendMobileCode,data).then(res=>{
            if(res.Result!=0){
            }else{
              that.times = 60;
              that.codeText = '发送验证码';
              that.isCode = false;
              clearInterval(that.timer);
              this.$message.error(res.Msg);
            }
          }).catch({})
        }else{
          that.isCode = true
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.$emit('closeDialog', 'forgot', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      console.log(this.flag, this.flagType)
    },
    // 判断input是否有值
    setInput(val) {
      this.$refs['ruleForm'].validateField('mobile',(val) => {
        if (val == "") {
        this.isCode = false
        }else{
        this.isCode = true
        }
      })
      // if (this.ruleForm.mobile != ''){
      //   this.isCode=false
      // }else{
      //   this.isCode=true
      // }
      if (val == 'oldpassword'|| val == 'password') {
        this.ruleForm[val] = isEmoji(this.ruleForm[val], 1)
      }
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '' && this.ruleForm.oldpassword != '' && this.ruleForm.code != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 登入
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading=true;
          that.disabled=true;
          that.ruleForm.NewPassword=that.ruleForm.password
          let data=that.ruleForm
          that.$post(that.$interface.ResetPassword,data).then(res=>{
            if(res.Result!=0){
              that.$message.success('修改成功');
              that.closeDialog()
              that.$emit('godialog', 'login', true)
            }else{
              that.$message.error(res.Msg);
            }
            that.loading=false;
          }).catch({})
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

</style>



// WEBPACK FOOTER //
// src/components/dialog/forgot.vue